import { render, staticRenderFns } from "./img-map.vue?vue&type=template&id=2c4c4eb2&scoped=true&"
import script from "./img-map.vue?vue&type=script&lang=js&"
export * from "./img-map.vue?vue&type=script&lang=js&"
import style0 from "./img-map.vue?vue&type=style&index=0&id=2c4c4eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c4eb2",
  null
  
)

export default component.exports